import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarRightHide20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSidebarRightHide20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 4.5h9v11h-9a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1m13 0H14v11h2.5a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1m0-1.5A2.5 2.5 0 0 1 19 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 1 14.5v-9A2.5 2.5 0 0 1 3.5 3zM6.063 8.055a.75.75 0 0 1 1.061-1.06L9.6 9.47l.53.53-.53.53-2.475 2.475a.75.75 0 0 1-1.06-1.06L8.007 10z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarRightHide20);
